import qs from 'query-string';
import api from './ApiService';

export async function getUsers(query) {
  const { data } = await api.get(`users?${qs.stringify(query)}`);
  return data;
}

export async function getAllUsers(query) {
  const { data } = await api.get(`users-all?${qs.stringify(query)}`);
  return data;
}

export async function getAllUsersNoWhere() {
  const { data } = await api.get(`users-all-no-where`);
  return data;
}

export async function getUserLog(query, id) {
  const { data } = await api.get(`access-logs/${id}?${qs.stringify(query)}`);
  return data;
}

export async function getUser(id) {
  const { data } = await api.get(`users/${id}`);
  return data;
}

export async function deleteUser(id) {
  await api.delete(`users/${id}`);
  return true;
}

export async function postUser(params) {
  await api.post(`users`, params);
  return true;
}

export async function putUser(id, params) {
  await api.put(`users/${id}`, params);
  return true;
}
